import React from "react";
import styles from "../index.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { PlatformId } from "views/page-content/platforms/types";
import { useTranslation } from "react-i18next";
import { AppDispatch } from "store/store";
import { updateGeneralForm } from "store/platforms/slice";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";
import { Button } from "components/buttons/Button";
import PencilIcon from "assets/icons/pencil-simple.svg?react";
import { DestinationLogo } from "./DestinationLogo";

export const DestinationDisplay = ({
    setSelectedPlatform,
    advanceToPlatformSettings
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const generalForm = useSelector(
        (s: RootState) => s.platforms.general.generalForm
    );
    let selectedDests = generalForm.selectedSimulcastDestinations;

    selectedDests = selectedDests.filter(
        (d) => d.platform !== PlatformId.VideoPlayer
    ) as DestinationDescriptor[];

    const removeDestination = (destination: DestinationDescriptor) => {
        dispatch(
            updateGeneralForm({
                selectedSimulcastDestinations: selectedDests.filter(
                    (d) => d.id !== destination.id
                )
            })
        );
    };

    if (!selectedDests || !selectedDests.length) {
        return null;
    }

    return (
        <ul className={styles["selected-destinations"]}>
            {selectedDests.map((destination, i) => {
                return (
                    <li key={i} className={styles["selected-destination"]}>
                        <DestinationLogo destination={destination} />
                        <p>{destination.name}</p>
                        <Button
                            type="icon"
                            onClick={() => {
                                setSelectedPlatform(
                                    destination.platform as PlatformId
                                );
                                advanceToPlatformSettings();
                            }}
                        >
                            <PencilIcon />
                        </Button>
                        <Button
                            type="remove"
                            onClick={() => removeDestination(destination)}
                        >
                            {t("buttons:remove")}
                        </Button>
                    </li>
                );
            })}
        </ul>
    );
};
